import type React from 'react';

import { Badge } from '@change/ds-core-ui';

import { useIsMobile } from '../../../../hooks/useIsMobile';

type Props = {
	label: string;
};

export const NavBadge: React.FC<Props> = ({ label }) => {
	const isMobile = useIsMobile();
	return isMobile ? (
		<Badge
			data-testid="mobile-badge"
			size="dot"
			variant="success"
			emphasis="strong"
			className="absolute ml-[-3px] inline-block px-0"
		/>
	) : (
		<Badge
			data-testid="desktop-badge"
			label={label}
			size="tiny"
			variant="information"
			emphasis="strong"
			className="justify-center px-1.5"
		/>
	);
};
